<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6">
            <label for="">{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              collapse-tags
              clearable
              multiple
              filterable
              @change="
                selectAllFromSelect('perimeterStatusForm.farm_ids', farms)
              "
              style="width: 100%"
              class="select-primary mb-3 required-farm_advanced shadow-sm"
              v-model="perimeterStatusForm.farm_ids"
              :placeholder="`${$t('common_words.select2')}...`"
            >
              <el-option
                class="select-primary selected-all"
                v-for="item in farms"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6">
            <label for="">{{ $t('diseases.disease') }}: </label>
            <br />
            <el-select
              @change="
                selectAllFromSelect(
                  'perimeterStatusForm.diseases_ids',
                  diseases
                )
              "
              collapse-tags
              clearable
              multiple
              filterable
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-disease_advanced"
              v-model="perimeterStatusForm.diseases_ids"
              :placeholder="`${$t('common_words.select2')}...`"
            >
              <el-option
                class="select-primary selected-all"
                v-for="item in diseases"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <label>{{ $t('common_words.analyze_by') }} </label>
            <br />
            <el-select
              @change="changeByInterval"
              filterable
              @clear="perimeterStatusForm.bySel = null"
              clearable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="perimeterStatusForm.bySel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in optionsInterval"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-sm-6 col-md-6"
            v-if="
              perimeterStatusForm.bySel != 'week' &&
              perimeterStatusForm.bySel != 'year'
            "
          >
            <label>{{ $t('common_words.calendar') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              v-model="rangeDate"
              class="shadow-sm required-year"
              v-bind:type="typedatepicket"
              :picker-options="pickerOptions"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
              :start-placeholder="$t('common_words.initial_date')"
              :end-placeholder="$t('common_words.final_date')"
            >
            </el-date-picker>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-right: 0; padding-top: 29px"
            v-if="
              perimeterStatusForm.bySel == 'week' ||
              perimeterStatusForm.bySel == 'year'
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="perimeterStatusForm.year_sel_init"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              perimeterStatusForm.bySel == 'week' &&
              perimeterStatusForm.year_sel_init
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-week shadow-sm"
              size="large"
              v-model="perimeterStatusForm.week_sel_init"
            >
              <el-option
                v-for="(week, index) in 53"
                class="select-primary"
                :value="week"
                :label="week"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              perimeterStatusForm.bySel == 'week' ||
              perimeterStatusForm.bySel == 'year'
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="perimeterStatusForm.year_sel_end"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              perimeterStatusForm.bySel == 'week' &&
              perimeterStatusForm.year_sel_end
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-week shadow-sm"
              size="large"
              v-model="perimeterStatusForm.week_sel_end"
            >
              <el-option
                v-for="(week, index) in 53"
                class="select-primary"
                :value="week"
                :label="week"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
      </card>
      <el-dialog
        v-if="isUpdate()"
        :title="$t('common_words.perimeter_status_edit')"
        :visible.sync="modals.read"
        width="75%"
        top="2%"
      >
        <p>
          {{ $t('common_words.selected_record_info') }}
        </p>
        <form @submit.prevent="validateStatus" v-if="this.isUpdate()">
          <card class="shadow-sm">
            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="col-12">
                    <h6 class="text-muted">
                      1. {{ $t('common_words.geo_position_sample') }}
                    </h6>
                    <hr />
                  </div>
                </div>
                <div class="col-12">
                  <div ref="map" class="map" style="height: 400px"></div>
                </div>
              </div>
              <div class="col-7">
                <div class="row">
                  <div class="col-12">
                    <h6 class="text-muted">
                      2. {{ $t('common_words.status_history') }}
                    </h6>
                    <hr />
                  </div>
                </div>
                <div
                  class="row"
                  v-for="(state, index) in editStatusForm.statusHistory"
                  :key="index"
                >
                  <div class="col-4">
                    <label>{{ $t('common_words.status') }}</label>
                    <el-select
                      clearable
                      class="select-primary custom-width-select bus-rels mb-3 required-state shadow-sm"
                      v-model="state.state"
                      aria-controls="datatables"
                      :disabled="
                        state.state == 5
                          ? true
                          : index === editStatusForm.statusHistory.length - 1
                          ? false
                          : true
                      "
                    >
                      <el-option
                        v-for="option in optionsStates"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                        :disabled="option.disabled"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <template v-if="validateEradication(state.state)">
                    <div class="col-4">
                      <label>{{
                        $t('diseases.plants_erradicated_numbers')
                      }}</label>
                      <el-input
                        clearable
                        class="mb-3 shadow-sm"
                        type="number"
                        v-model="state.erradicated_plants"
                        aria-controls="datatables"
                        :disabled="
                          index === editStatusForm.statusHistory.length - 1
                            ? false
                            : true
                        "
                      />
                    </div>
                    <div class="col-4">
                      <label
                        >{{ $t('common_words.area_erradicated') }} ({{
                          getOptionsStates(state.state)
                        }})</label
                      >
                      <el-input
                        clearable
                        class="mb-3 shadow-sm"
                        type="number"
                        v-model="state.erradicated_area"
                        aria-controls="datatables"
                        :disabled="
                          index === editStatusForm.statusHistory.length - 1
                            ? false
                            : true
                        "
                      />
                    </div>
                  </template>
                  <div class="col-4">
                    <label>{{ $t('common_words.date_of_record') }}</label>
                    <el-input
                      v-model="state.state_date"
                      type="datetime"
                      class="mb-3 shadow-sm"
                      style="width: 100%"
                      disabled
                    />
                  </div>
                  <div class="col-12">
                    <label>{{ $t('common_words.observations') }}</label>
                    <el-input
                      type="textarea"
                      :rows="4"
                      :placeholder="$t('common_words.observations')"
                      v-model="state.observations"
                      :disabled="
                        index === editStatusForm.statusHistory.length - 1
                          ? false
                          : true
                      "
                    />
                    <hr />
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-12 form-group has-label"
                    style="margin-top: 30px"
                  >
                    <button
                      type="submit"
                      class="btn btn-fill btn-info btn-wd shadow-sm"
                    >
                      {{ $t('common_words.edit') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </card>
        </form>
        <br />
      </el-dialog>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        title="Reporte De Estados De Perímetros"
        v-if="perimeterReport"
      >
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <el-select
            clearable
            @clear="pagination.perPage = 10"
            class="select-default mb-3 shadow-sm"
            style="width: 200px"
            v-model="pagination.perPage"
            :placeholder="$t('common_words.per_page')"
            filterable
          >
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-input
            clearable
            class="mb-3 shadow-sm"
            style="width: 200px"
            :placeholder="$t('common_words.search_records')"
            v-model="searchQuery"
            aria-controls="datatables"
          />
        </div>
        <div class="col-sm-12">
          <el-table
            stripe
            :default-sort="{ prop: 'name', order: 'ascending' }"
            :data="queriedData"
            max-height="500"
            style="width: 100%"
            :border="true"
          >
            <el-table-column
              :render-header="renderHeader"
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :fixed="column.fixed"
              :sortable="column.sortable"
              :align="column.align"
              :resizable="false"
            >
            </el-table-column>

            <el-table-column
              :label="$t('common_words.status_last')"
              minWidth="150"
              :sortable="true"
              :resizable="false"
              :align="'center'"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.perimeters[scope.row.perimeters.length - 1]
                      .perimeterCondition
                  "
                  >{{
                    scope.row.perimeters[scope.row.perimeters.length - 1]
                      .perimeterCondition.name
                  }}</span
                >
                <span v-else>{{ 'N/E' }}</span>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('common_words.date_last_status')"
              minWidth="150"
              :sortable="true"
              :resizable="false"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  formatDate(
                    scope.row.perimeters[scope.row.perimeters.length - 1]
                      .state_date
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="70"
              :label="$t('common_words.action')"
              fixed="right"
              :resizable="false"
            >
              <template slot-scope="props">
                <div class="text-center">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.edit')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <em class="fa fa-edit custom-size-fa-actions"></em>
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import moment from 'moment';
import store from '@/store';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import mixinMasters from 'src/util/mixinMasters';
import configTable from './perimetersTable.js';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import { Pagination as LPagination } from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import axios from 'axios';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,
    optionsInterval() {
      return {
        0: { label: this.$i18n.t('common_words.day'), value: 'daterange' },
        1: { label: this.$i18n.t('common_words.week'), value: 'week' },
        2: { label: this.$i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.avancedReportForm.bySel
        ).label;
      } catch (error) {
        return 'Intervalo';
      }
    },
  },
  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinArcgisMap,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  data() {
    return {
      perimeterStatusForm: {
        bySel: 'Semana',
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        diseases_ids: [],
        farm_ids: [],
      },

      editStatusForm: {
        statusHistory: [],
        prevState: null,
        state_date: null,
        unit: null,
      },

      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      typedatepicket: 'daterange',
      optionsStates: [],
      modals: { read: false },
      farms: [],
      years: [],
      diseases: [],
      tableData: [],
      searchQuery: '',
      perimeterReport: false,
      pagination: {},
      tableColumns: [],
      stateIsEradication: false,
    };
  },
  watch: {
    '$i18n.locale': ['getSelectAll', 'setupTable', 'forceRerender'],
  },
  methods: {
    getSelectAll() {
      this.diseases = this.concatAll(this.diseases.splice(1));
      this.farms = this.concatAll(this.farms.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    getOptionsStates(id) {
      const valorunit = this.optionsStates.find((option) => option.id === id);
      try {
        return valorunit.unit.toUpperCase();
      } catch (error) {
        return '';
      }
    },
    getColorPerimeter(id) {
      const perimeterCondition = this.optionsStates.find(
        (option) => option.id === id
      );
      try {
        return perimeterconditions.color;
      } catch (error) {
        return '';
      }
    },

    validateEradication(stateId) {
      const index = this.optionsStates.findIndex(
        (state) => state.id === stateId
      );
      if (
        this.optionsStates[index] &&
        this.optionsStates[index].eradication === 1
      ) {
        return true;
      }
      return false;
    },

    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label.split('-')[0]),
        h('br'),
        h('span', column.label.split('-')[1]),
      ]);
    },

    updateState() {
      const {
        code,
        code_detail,
        observations,
        state,
        erradicated_area,
        erradicated_plants,
      } =
        this.editStatusForm.statusHistory[
          this.editStatusForm.statusHistory.length - 1
        ];

      let form = {
        route: 'auth/diseases/perimeterstatus',
        code,
        code_detail,
        state,
        observations,
        prevState: this.editStatusForm.prevState,
        erradicated_plants,
        erradicated_area,
      };
      axios
        .put(form.route, form)
        .then((response) => {
          this.modals['read'] = false;
          SweetAlert.success(response.data.message);
          this.perimeterReport = false;
        })
        .catch((error) => {
          this.perimeterReport = false;
          SweetAlert.warning(error.response.data.message);
        });
    },

    validateStatus() {
      let lastIndex = this.editStatusForm.statusHistory.length - 1;
      if (this.editStatusForm.statusHistory[lastIndex].state === '') {
        return this.validationInputsRequired('state');
      } else {
        this.updateState();
      }
    },

    validate() {
      this.tableData = [];
      this.perimeterReport = false;
      if (this.perimeterStatusForm.farm_ids.length === 0) {
        return this.validationInputsRequired('farm_advanced');
      } else if (this.perimeterStatusForm.diseases_ids.length === 0) {
        return this.validationInputsRequired('disease_advanced');
      } else if (
        this.perimeterStatusForm.bySel != 'daterange' &&
        this.perimeterStatusForm.bySel != 'monthrange' &&
        (this.perimeterStatusForm.year_sel_init == null ||
          this.perimeterStatusForm.year_sel_end == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isYearSelRequired() &&
        this.perimeterStatusForm.year_sel_end == null &&
        this.perimeterStatusForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.perimeterStatusForm.week_sel_init == null &&
        this.perimeterStatusForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.perimeterStatusForm.week_sel_end == null &&
        this.perimeterStatusForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.rangeDate == null) {
        return this.validationInputsRequired('year');
      } else {
        this.loadStatusReport();
      }
    },

    handleEdit(index, rowData) {
      this.modals['read'] = true;
      this.editStatusForm.prevState =
        rowData.perimeters[rowData.perimeters.length - 1].state;

      this.editStatusForm.state_date = rowData.perimeters.state_date;

      this.editStatusForm.statusHistory = [];
      rowData.perimeters.forEach((element) => {
        this.editStatusForm.statusHistory.push(Object.assign({}, element));
      });

      let state_number = this.editStatusForm.statusHistory.map(
        (state) => state.state
      );
      this.optionsStates.forEach((option, index) => {
        if (state_number[state_number.length - 1] > option.state) {
          option['disabled'] = true;
        } else {
          option['disabled'] = false;
        }
      });

      let points = [];
      let pll = new Object();
      pll.lat = parseFloat(rowData.latitude);
      pll.lng = parseFloat(rowData.longitude);
      pll.color = rowData.color;
      this.center.lat = rowData.latitude;
      this.center.lng = rowData.longitude;

      let sickPerimeter = null;
      //
      if (rowData.geometry_data != null) {
        sickPerimeter = rowData.geometry_data.split('/');
      }

      points.push(pll);

      if (points.length == 0) {
        SweetAlert.warning(i18n.t('sweet_alert.disease.unavailable_dates'));
      }
      let perimeterColor = rowData.perimeters[rowData.perimeters.length - 1]
        .perimeterCondition
        ? rowData.perimeters[rowData.perimeters.length - 1].perimeterCondition
            .color
        : '#fff';
      setTimeout(() => {
        this.loadBaseMap(
          rowData.farm_id,
          false,
          false,
          this.$refs.multipleMap,
          points,
          20,
          sickPerimeter,
          false,
          perimeterColor, // esta
          rowData.disease_name
        );
        // document.getElementById("toolbarDiv").style = "top: 16%;right: 18px;";
        this.showHideLoading();
      }, 10);
    },

    loadData() {
      this.pagination.currentPage = 1;
      let data = {
        farms: this.perimeterStatusForm.farm_ids,
        init: null,
        end: null,
        bySel: this.perimeterStatusForm.bySel,
        diseases: this.perimeterStatusForm.diseases_ids,
      };

      switch (this.perimeterStatusForm.bySel) {
        case 'year':
          data.init = this.perimeterStatusForm.year_sel_init;
          data.end = this.perimeterStatusForm.year_sel_end;
          break;
        case 'monthrange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
        case 'week':
          data.init = `${this.perimeterStatusForm.year_sel_init}-${(
            '0' + this.perimeterStatusForm.week_sel_init
          ).slice(-2)}`;
          data.end = `${this.perimeterStatusForm.year_sel_end}-${(
            '0' + this.perimeterStatusForm.week_sel_end
          ).slice(-2)}`;
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadStatusReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'diseases/perimeterstatus';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.tableData = response.data;
            if (this.tableData.length == 0) {
              SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            } else {
              this.fuseSearch = new Fuse(this.tableData, {
                useExtendedSearch: true,
                keys: this.tableColumns.map((column) => column.prop),
              });
              this.perimeterReport = true;
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'week';
    },

    isWeekSekRequired() {
      return this.interval == 'week';
    },

    changeByInterval() {
      this.perimeterReport = false;
      this.typedatepicket = this.perimeterStatusForm.bySel;
    },
    setupTable() {
      const { Table } = configTable();
      // Assign the Table and Search objects to your data properties
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('diseases/diseasesonly'),
        Axios.getMasters('diseases/perimeterconditions/indexfield'),
      ])
        .then((response) => {
          this.farms = this.concatAll(response[0].data.data);
          this.diseases = this.concatAll(response[1].data);
          this.optionsStates = response[2].data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('diseases/advancedreport/years').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },
};
</script>
